import { useRef, useEffect } from 'react';

const shared = { x: 0, y: 0 };
const target = { x: 0, y: 0 };

if (typeof window !== 'undefined') {
  window.addEventListener('mousemove', (e) => {
    target.x = (e.clientX / window.innerWidth - 0.5) * 2;
    target.y = -(e.clientY / window.innerHeight - 0.5) * 2;
  }, { passive: true });
}

// Lerp happens in CameraManager's useFrame; this just exposes the ref
export function useMouseLerp() {
  const mouseRef = useRef(shared);

  useEffect(() => {
    let raf;
    const tick = () => {
      shared.x += (target.x - shared.x) * 0.08;
      shared.y += (target.y - shared.y) * 0.08;
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  return { mouse: mouseRef.current };
}
